'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _noImagePanel = require('../../../../molecules/no-image-panel');

var _noImagePanel2 = _interopRequireDefault(_noImagePanel);

var _imagePanel = require('../../../../molecules/image-panel');

var _imagePanel2 = _interopRequireDefault(_imagePanel);

var _iconPanel = require('../../../../molecules/icon-panel');

var _iconPanel2 = _interopRequireDefault(_iconPanel);

var _dataPointPanel = require('../../../../molecules/data-point-panel');

var _dataPointPanel2 = _interopRequireDefault(_dataPointPanel);

var _linkPanel = require('../../../../molecules/link-panel');

var _linkPanel2 = _interopRequireDefault(_linkPanel);

var _videoPanel = require('../../../../molecules/video-panel');

var _videoPanel2 = _interopRequireDefault(_videoPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { className: 'panels__headline', level: '2' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderDefaultChildren = function renderDefaultChildren(items) {
  if (items) {
    return items.map(function (elem) {
      return _react2.default.createElement(_noImagePanel2.default, elem);
    });
  }
  return null;
};

var renderSubheadline = function renderSubheadline(subheadline) {
  if (subheadline && subheadline.text) {
    return _react2.default.createElement(
      _heading2.default,
      { className: 'panels__subheadline h4', level: '3' },
      htmlToReactParser.parse(subheadline.text)
    );
  }
  return null;
};

var renderFooter = function renderFooter(footer) {
  if (footer && footer.text) {
    return _react2.default.createElement(
      'div',
      { className: 'panels__footer row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12' },
        _react2.default.createElement(
          'p',
          { className: 'text-xs-center legal-notes' },
          htmlToReactParser.parse(footer.text)
        )
      )
    );
  }
  return null;
};

var Panels = function (_React$Component) {
  _inherits(Panels, _React$Component);

  function Panels(props) {
    _classCallCheck(this, Panels);

    var _this = _possibleConstructorReturn(this, (Panels.__proto__ || Object.getPrototypeOf(Panels)).call(this, props));

    _this.sectionElement = null;
    _this.state = {
      showImages: false
    };
    _this.columnClasses = {
      2: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 panels__panel',
      3: 'col-lg-4 col-md-4 col-sm-12 col-xs-12 panels__panel',
      4: 'col-lg-3 col-md-6 col-sm-12 col-xs-12 panels__panel'
    };
    _this.handleScroll = _this.handleScroll.bind(_this);
    // adding references in case this component is extended
    _this.renderHeadline = renderHeadline;
    _this.renderDefaultChildren = renderDefaultChildren;
    _this.renderSubheadline = renderSubheadline;
    _this.renderFooter = renderFooter;
    return _this;
  }

  _createClass(Panels, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement ? this.sectionElement.getBoundingClientRect() : null;
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderDeviceImage',
    value: function renderDeviceImage(deviceImage) {
      if (this.state.showImages && deviceImage && deviceImage.url) {
        return _react2.default.createElement('span', {
          className: 'panels__device-image',
          style: { backgroundImage: 'url(' + deviceImage.url + ')' }
        });
      }
      return null;
    }
  }, {
    key: 'renderPanels',
    value: function renderPanels(children) {
      if (children) {
        var panelsChildren = Array.isArray(children) ? children : [children];
        var rows = [];
        var panels = [];
        for (var pnlIdx = 0; pnlIdx < panelsChildren.length; pnlIdx += 1) {
          var elem = panelsChildren[pnlIdx];
          var component = _react2.default.cloneElement(elem, { pnlIdx: pnlIdx });
          panels.push(_react2.default.createElement(
            'div',
            { className: this.columnsClass, key: pnlIdx },
            component
          ));
          if ((pnlIdx + 1) % this.props.config.columns === 0 || pnlIdx === panelsChildren.length - 1) {
            rows.push(_react2.default.createElement(
              'div',
              { className: 'row', key: pnlIdx },
              panels
            ));
            panels = [];
          }
        }
        return rows;
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      var _props$content = this.props.content,
          headline = _props$content.headline,
          subheadline = _props$content.subheadline,
          footer = _props$content.footer,
          items = _props$content.items;
      var _props$config = this.props.config,
          id = _props$config.id,
          theme = _props$config.theme,
          center = _props$config.center,
          deviceImage = _props$config.deviceImage;


      var panelsClasses = (0, _classnames2.default)('panels', theme, className, {
        center: center,
        'device-image': deviceImage && deviceImage.url
      });

      var children = this.props.children || renderDefaultChildren(items);

      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: panelsClasses,
          'data-building-block': 'organism',
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.renderDeviceImage(deviceImage),
          _react2.default.createElement(
            'div',
            { className: 'row text-xs-center panels__header' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              renderHeadline(headline),
              renderSubheadline(subheadline)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'panels__container' },
            this.renderPanels(children)
          ),
          renderFooter(footer)
        )
      );
    }
  }, {
    key: 'columnsClass',
    get: function get() {
      var config = this.props.config && this.props.config.columns;
      return this.columnClasses[config] || this.columnClasses[4];
    }
  }]);

  return Panels;
}(_react2.default.Component);

/* Set default configurations and prevent TypeError for missing [object].
   Else, you need to test if object exist. */


exports.default = Panels;
Panels.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-white', 'theme-background-color-light']).isRequired,
    center: _propTypes2.default.bool,
    deviceImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired
    }),
    columns: _propTypes2.default.oneOf([1, 2, 3, 4]).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    subheadline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    items: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape(_noImagePanel2.default.propTypes), _propTypes2.default.shape(_imagePanel2.default.propTypes), _propTypes2.default.shape(_dataPointPanel2.default.propTypes), _propTypes2.default.shape(_iconPanel2.default.propTypes), _propTypes2.default.shape(_linkPanel2.default.propTypes), _propTypes2.default.shape(_videoPanel2.default.propTypes)])).isRequired,
    footer: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element])
};

/* Example of Content.json passed as default */
Panels.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-blue',
    columns: 4,
    center: false,
    deviceImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/paypal-on-devices-home.png'
    }
  },
  content: {
    headline: {
      text: '34 characters maximum'
    },
    subheadline: {
      text: '140 characters maximum for optional paragraphs which ' + 'appear above panels and are used to introduce the options presented below.'
    },
    items: [_noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps],
    footer: {
      text: '110 characters maximum for optional Hatch Text which ' + 'appears below panels and can contain links.'
    }
  },
  className: '',
  children: null
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/main/jsx/Panels.js
// module id = 412
// module chunks = 4